"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.execTimify = void 0;
const utils_1 = require("../common/utils/utils");
const reporter = function (data) {
    // eslint-disable-next-line no-console
    console.info(data.execTime);
};
function execTimify(originalMethod, arg) {
    const input = arg !== null && arg !== void 0 ? arg : reporter;
    return function (...args) {
        return __awaiter(this, void 0, void 0, function* () {
            const repFunc = typeof input === 'string' ? this[input].bind(this) : input;
            const start = Date.now();
            let result = originalMethod.apply(this, args);
            if ((0, utils_1.isPromise)(result)) {
                result = yield result;
            }
            repFunc({
                args,
                result,
                execTime: Date.now() - start,
            });
        });
    };
}
exports.execTimify = execTimify;
